export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const EMAIL_CHANGE = 'EMAIL_CHANGE';
export const PASSWORD_CHANGE = 'PASSWORD_CHANGE';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
export const AUTH_TOKEN_CHANGE = 'AUTH_TOKEN_CHANGE';



// WEBPACK FOOTER //
// ./src/containers/common/auth/constants.js